import './SharedDataDictionaryView.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { GatewayContent } from '../../gateway/general';
import { NoData } from '@ui/NoData';
import { PoweredByArovy } from '@ui/icons';
import React from 'react';
import { SharedDataDictionary } from './SharedDataDictionary';
import { Space } from 'antd';
import { useParams } from 'react-router-dom';
import { ViewArea } from '@ui/general';

import { useAction, useOnMount, useSonarSelector } from '@hooks';

const sharedViewSelectors = createAsyncSelectors((state) => state.core.dataDictionary.views.sharedKey.get);

export const SharedDataDictionaryView: React.FC = () => {
	const { id } = useParams<{ id: string }>();

	const isIdle = useSonarSelector(sharedViewSelectors.isIdle);
	const isErrored = useSonarSelector(sharedViewSelectors.isErrored);
	const isFailed = useSonarSelector(sharedViewSelectors.isFailed);
	const isRequesting = useSonarSelector(sharedViewSelectors.isRequested);
	const data = useSonarSelector(sharedViewSelectors.data);

	const requestView = useAction(coreActions.requestGetCoreDataDictionaryViewsSharedKey);

	useOnMount(() => {
		if (id) {
			requestView({
				count: 10,
				sharedKey: id
			});
		}
	});

	if (isErrored || isFailed) {
		return (
			<Space
				align='center'
				className='invalid-view'
				direction='vertical'>
				<NoData
					className='invalid-view-empty'
					description={
						<>
							<span>{ COPY_SPECIFIC.INVALID_LINK }</span>
							<br />
							<span>{ COPY_SPECIFIC.CONTACT_AROVY_ADMIN }</span>
						</>
					} />
				<PoweredByArovy />
			</Space>
		);
	}

	if (isIdle || (isRequesting && !data)) {
		return <GatewayContent />;
	}

	return (
		<ViewArea
			className='shared-data-dictionary-view'
			direction='vertical'
			fullHeight
			fullWidth
			id='data-dictionary-view'>
			<SharedDataDictionary
				data={ data }
				loading={ isRequesting }
				viewKey={ id ?? '' } />
		</ViewArea>
	);
};
